import React, { useMemo } from "react"

import moment from "moment"

import { AgenticCheckStatus } from "@common-shared/config/oneVerify/oneVerifyCoverage.config.ts"
import { IAgenticCoverageCheck } from "@common-shared/types/responseData/oneVerifyResponseData.types.ts"

import { NIRVANA_COLORS } from "@front-shared/config/theme.config.ts"
import { PrimaryText } from "@front-shared/elements/primaryText.element.tsx"

import { GENERAL_CONFIG } from "../../../config/general.config"
import { POLICIES_CONFIG } from "../../../config/policies.config"

import phoneIcon from "@front-shared/assets/images/icons/phone.svg"

export const AgenticCheckStatusComponent: React.FunctionComponent<
    IAgenticCheckStatusComponentProps
> = props => {
    const isPendingAgenticCheck = useMemo<boolean>(() => {
        return (
            !!props.agenticCheck &&
            POLICIES_CONFIG.pendingAgenticStatuses.includes(
                props.agenticCheck.status,
            )
        )
    }, [props.agenticCheck?.status])

    const statusClassName = useMemo<string>(() => {
        switch (props.agenticCheck?.status) {
            case AgenticCheckStatus.FINISHED:
                return "bg-brand-greenLight border-brand-green2"

            case AgenticCheckStatus.FAILED:
                return "bg-brand-paleRed border-brand-error"

            default:
                return "bg-brand-grey5"
        }
    }, [props.agenticCheck?.status])

    return props.agenticCheck ? (
        <div
            className={`
                ${props.className}
                flex items-center
                ${
                    !props.backgroundFree
                        ? `${statusClassName} py-[8px] px-[16px] rounded-[8px] border border-solid`
                        : ""
                }
            `}
        >
            <div className="mr-[12px]">
                <img
                    src={
                        isPendingAgenticCheck
                            ? phoneIcon
                            : POLICIES_CONFIG.agenticCheckStatusIconsMapping[
                                  props.agenticCheck.status
                              ]
                    }
                    alt="status"
                    className="w-[16px] h-[16px]"
                    style={
                        isPendingAgenticCheck
                            ? {
                                  filter: "brightness(0) saturate(100%) invert(27%) sepia(51%) saturate(2878%) hue-rotate(230deg) brightness(104%) contrast(97%)",
                              }
                            : {}
                    }
                />
            </div>

            <div>
                <PrimaryText
                    weight="medium"
                    color={NIRVANA_COLORS.brand.deepPurple}
                >
                    {
                        POLICIES_CONFIG.agenticCheckStatusMapping[
                            props.agenticCheck.status
                        ]
                    }
                </PrimaryText>

                {isPendingAgenticCheck && (
                    <PrimaryText
                        typography="textSmall"
                        color={NIRVANA_COLORS.brand.grey7}
                    >
                        Initiated{" "}
                        {moment(props.agenticCheck.createdAt).format(
                            `${GENERAL_CONFIG.defaultMomentDateFormat} [at] ${GENERAL_CONFIG.defaultMomentHourMinutesFormat}`,
                        )}
                    </PrimaryText>
                )}
            </div>
        </div>
    ) : null
}

interface IAgenticCheckStatusComponentProps {
    className?: string
    agenticCheck: IAgenticCoverageCheck | null
    backgroundFree?: boolean
}
